<ng-container *ngIf="isValidState">
    <span>Viewing {{fromItem}} to {{toItem}} of {{count}} results.</span>
</ng-container>